var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebar__row" }, [
    _c("nav", { class: "" + _vm.classPrefix }, [
      _c("ul", { class: _vm.classPrefix + "__links" }, [
        _c(
          "li",
          {
            staticClass: "sidebar__signout",
            class: _vm.classPrefix + "__link-item"
          },
          [
            _c(
              "a",
              {
                attrs: { href: "/logout/" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.logout($event)
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "sidebar__signout-icon",
                    class: _vm.classPrefix + "__link-icon"
                  },
                  [_c("i", { staticClass: "fa fa-sign-out-alt" })]
                ),
                _vm._v(" "),
                _c("p", { class: _vm.classPrefix + "__link" }, [
                  _vm._v("Sign out")
                ])
              ]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }